// extracted by mini-css-extract-plugin
module.exports = {"iconButtons":"GroupTable_iconButtons__2IEC5","actions":"GroupTable_actions__ptfmM","deleteModalFooter":"GroupTable_deleteModalFooter__2entF"};